/** Labour contract activities — keep in sync with backend/labour/activities.py */

export const LABOUR_ACTIVITY_OPTIONS = [
  { value: "UNLOAD_TO_STACK", label: "Unload to stack" },
  { value: "STACK_TO_HOUDI", label: "Stack to houdi" },
  { value: "FLOOR_TO_STACK", label: "Floor to stack" },
  { value: "STACK_TO_LOADING", label: "Stack to loading" },
  { value: "FLOOR_TO_LOADING", label: "Floor to loading" },
  { value: "UNLOAD_TO_HOUDI", label: "Unload to houdi" },
];

const LEGACY_LABELS = {
  UNLOADING: "Unloading (legacy)",
  LOADING: "Loading (legacy)",
  DALA: "Dala (legacy)",
};

export function labourActivityLabel(code) {
  if (!code) return "";
  const hit = LABOUR_ACTIVITY_OPTIONS.find((a) => a.value === code);
  if (hit) return hit.label;
  return LEGACY_LABELS[code] || code.replace(/_/g, " ").toLowerCase();
}
